import API from "serviceshift-ui/api-client";
import { generateReqParams } from "@/lib/helpers.js";

import { reportApiFailure } from "@/vuex/interceptors";

export default {
  archiveCrewMember(_, { link }) {
    return API.makeRequest(link.href, {
      method: link.method
    });
  },
  fetchCrewMembers({ commit }, { link }) {
    return API.makeRequest(link.href, {
      method: link.method
    }).then((res) => {
      commit("replace", {
        state: "crewMembers",
        data: res.data
      });
      return res;
    });
  },
  assignCrewMember({ state, commit }, { link, technicianId, memberId }) {
    // Optimistically update UI with assignment
    const { crewMembers } = state;
    commit("replace", {
      state: "crewMembers",
      data: crewMembers.map((member) => {
        if (memberId === member.id) {
          return {
            ...member,
            assigned_to: {
              user_id: technicianId,
              full_name: "Keith Morris",
              department: {
                id: 1,
                name: "1 - Plumbing Technicians"
              }
            }
          };
        }
        return member;
      })
    });
    const params = generateReqParams(
      { PARAM_TECH_ID: technicianId },
      link.parameters
    );
    return API.makeRequest(link.href, {
      method: link.method,
      data: params
    });
  },
  unassignCrewMember(_, { link }) {
    return API.makeRequest(link.href, {
      method: link.method
    });
  },
  unarchiveCrewMember(_, { link }) {
    return API.makeRequest(link.href, {
      method: link.method
    });
  },
  unassignAllCrewMembers(_, { link }) {
    return API.makeRequest(link.href, {
      method: link.method
    });
  },
  // The caller shows its own inline error. ignoreError also skips the
  // interceptor's RUM report, so report here; a 401 is left to its redirect.
  async fetchCrewMemberLaborRate(_, { link }) {
    try {
      const response = await API.makeRequest(link.href, {
        method: link.method,
        headers: { ignoreError: true }
      });
      return response.data;
    } catch (error) {
      const status = error?.response?.status;
      if (status && status !== 401) {
        reportApiFailure(error, "crew_member_labor_rate_load");
      }
      throw error;
    }
  },
  upsertCrewMember(_, { link, data }) {
    return API.makeRequest(link.href, {
      method: link.method,
      data
    });
  }
};
